<template>
  <div>
    <UnauthorizedBlock>
      <form @submit.prevent="" v-if="!success" class="grid grid-cols-1 row-gap-8">
        <div class="text-xl font-bold text-text leading-tight">
          {{ $t('title') }}
        </div>
        <BaseInput v-model.trim="$v.email.$model"
                   :label="$t('emailLabel')"
                   :class="{'--error':$v.email.$error || !!serverErrors }">
          <template v-slot:errors="">
            <div class="error" v-if="!$v.email.required">{{ $t('errors.required') }}</div>
            <div class="error" v-if="!!serverErrors">{{ serverErrors.email }}</div>
          </template>
        </BaseInput>
        <BaseButton theme="red"
                    @click="restoreBtn"
                    :loading="submitted"
                    class="w-full">
          {{ $t('restore') }}
        </BaseButton>

        <router-link class="text-2sm text-text-label leading-tight mx-auto
                            transition duration-200 hover:text-red"
                     :to="{name:'login'}">{{ $t('iRemembered') }}
        </router-link>
      </form>

      <div v-else class="text-center -mx-8">
        <div class="text-xl font-bold text-text leading-tight mb-4">
          {{ $t('successTitle') }}
        </div>
        <div class="text-md font-medium text-text leading-tight">
          {{ $t('successText') }}
        </div>
      </div>
    </UnauthorizedBlock>
    <RecaptchaBranding/>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import {required} from 'vuelidate/lib/validators'
import UnauthorizedBlock from "@/components/layouts/common/UnauthorizedBlock";
import BaseInput from "@/components/UI/BaseInput/BaseInput";
import BaseButton from "@/components/UI/BaseButton";
import RecaptchaBranding from "@/components/common/RecaptchaBranding";

export default {
  name: 'RestorePassword',
  components: {
    RecaptchaBranding,
    BaseButton,
    BaseInput,
    UnauthorizedBlock,
  },
  data() {
    return {
      email: '',
      submitted: false,
      success: false,
      serverErrors: ''
    }
  },
  validations: {
    email: {
      required,
    },
  },
  methods: {
    ...mapActions('auth', ['restore']),
    showErrors(message) {
      this.serverErrors = message;
    },
    clearErrors() {
      this.serverErrors = '';
    },
    async restoreBtn() {
      this.submitted = true;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let restoreData = {
          email: this.email
        };

        await this.$recaptchaLoaded()
        restoreData.recaptcha_response = await this.$recaptcha('restore')

        this.restore(restoreData).then((res) => {
          if (res.data.success) {
            this.success = true;
            this.$v.$reset();
          } else {
            this.showErrors(res.body.message);
            setTimeout(() => {
              this.clearErrors()
            }, 5000);
          }
        });
        this.submitted = false;
      } else {
        this.submitted = false;
      }
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Restore password',
        emailLabel: 'Enter e-mail address',
        restore: 'Restore',
        iRemembered: 'I remembered password!',
        successTitle: 'Success!',
        successText: 'If you were registered with the specified email, within 5 minutes you will receive an email with instructions on how to reset your password.'
      },
      ru: {
        title: 'Восстановление пароля',
        emailLabel: 'Введите электронную почту',
        restore: 'Восстановить',
        iRemembered: 'Я вспомнил пароль!',
        successTitle: 'Успешно!',
        successText: 'Если вы были зарегистрированы с указаным email, в течение 5 минут вы получите письмо с инструкцией по восстановлению пароля.'
      }
    }
  }
}
</script>
